import React, { createContext, useState, useContext, useEffect } from 'react';

const FontSizeContext = createContext();

export const FontSizeProvider = ({ children }) => {
  // ????? ????????? 13px ?? ?? ??? ????
  const [fontSize, setFontSize] = useState(parseInt(localStorage.getItem('appFontSize')) || 13);

  const changeFontSize = (delta) => {
    setFontSize(prev => {
      const newSize = Math.min(Math.max(prev + delta, 10), 20); // ?????? ?? 10 ?? 20
      localStorage.setItem('appFontSize', newSize);
      return newSize;
    });
  };

  return (
    <FontSizeContext.Provider value={{ fontSize, changeFontSize }}>
      <div style={{ fontSize: `${fontSize}px` }}>
        {children}
      </div>
    </FontSizeContext.Provider>
  );
};

export const useFontSize = () => useContext(FontSizeContext);